const MinusIcon = (props) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"  {...props}>
      <g clipPath="url(#clip0_1528_5518)">
        <path d="M15.7034 10.7816H4.75V9.2168H15.7034V10.7816Z" fill={props?.fill || "white"} />
      </g>
      <defs>
        <clipPath id="clip0_1528_5518">
          <rect
            width="18.7772"
            height="18.7772"
            fill={props?.fill || "white"}
            transform="translate(0.839844 0.611328)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default MinusIcon;
